import * as React from 'react';

import { Dimensions, Platform, PixelRatio } from 'react-native';

import { AntDesign } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';


let { width, height } = Dimensions.get('window');


var scale = width / 640;

if (height > width) {
    scale = height / 500;
} 

export function log(text: string) {
 // console.log(text);
}

export function logerror(functionText: string, text: string) {
 // console.error(functionText + ": " + text);
}


